module.exports = __webpack_public_path__ + "img/IMG_9992.4c882b48.jpg";